angular.module('common.filter.truncateLongText', ['common.config'])
    .filter('truncateLongText', function (CONSTANTS) {
        return function (longText) {
            if (!longText) {
                return null;
            }
            if (longText.length > CONSTANTS.maxDescriptionLength) {
                longText = longText.slice(0, CONSTANTS.maxDescriptionLength) + '...';
            }
            return longText;
        };
    })
;



// WEBPACK FOOTER //
// ./app/common/filter/truncate-long-text-filter.js